import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

let routesDev = [
    /*{
        path: '/home',
        name: 'home',
        meta: {
            layout: 'blank',
            authNeeded: true,
            navigationActive: 'home',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/HomePage.vue'),
    },
    {
        path: '/search',
        name: 'search',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/Index.vue'),
    },*/
];





let routesProd = [
    /*{
        path: '/home',
        name: 'home',
        redirect: '/search'
    },
    {
        path: '/search',
        name: 'search',
        meta: {
            layout: 'blank',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/IndexHomePageVersion.vue'),
    }*/
];



let routesCommon = [
    {
        path: '/home',
        name: 'home',
        redirect: '/search'
    },
    {
        path: '/coming-soon/qualify',
        name: 'coming-soon-qualify',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'qualify',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/ComingSoon.vue'),
    },
    {
        path: '/search',
        name: 'search',
        meta: {
            layout: 'blank',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/Index.vue'),
    },
    {
        path: '/coming-soon/formation',
        name: 'coming-soon-formation',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'formation',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/ComingSoon.vue'),
    },
    //   ____  _____    _    ____   ____ _   _
    //  / ___|| ____|  / \  |  _ \ / ___| | | |
    //  \___ \|  _|   / _ \ | |_) | |   | |_| |
    //   ___) | |___ / ___ \|  _ <| |___|  _  |
    //  |____/|_____/_/   \_\_| \_\\____|_| |_|
    //
    // MACHINES
    {
        path: '/search-machines-filters',
        name: 'search-machines-filters',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/machines/Filters.vue'),
    },
    {
        path: '/search-machines-results',
        name: 'search-machines-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/machines/Results.vue'),
    },
    {
        path: '/best-sellers-results',
        name: 'best-sellers-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            landingType:'best_sellers'
        },
        component: () => import('../views/search/machines/LandingResults.vue'),
    },
    {
        path: '/new-machines-results',
        name: 'new-machines-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            landingType:'new_products'
        },
        component: () => import('../views/search/machines/LandingResults.vue'),
    },
    {
        path: '/low-emissions-results',
        name: 'low-emissions-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            landingType:'low_emissions'
        },
        component: () => import('../views/search/machines/LandingResults.vue'),
    },
    {
        path: '/search-machines-sub-filters',
        name: 'search-machines-sub-filters',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'slide-up',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/machines/SubFilters.vue'),
    },
    // ACCESSOIRES
    {
        path: '/search-accessories-filters',
        name: 'search-accessories-filters',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/accessories/Filters.vue'),
    },
    {
        path: '/search-accessories-results',
        name: 'search-accessories-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/accessories/Results.vue'),
    },
    // SERVICES
    {
        path: '/search-services-results',
        name: 'search-services-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/search/services/Results.vue'),
    },
    //   ____  _____    _    ____   ____ _   _
    //  / ___|| ____|  / \  |  _ \ / ___| | | |
    //  \___ \|  _|   / _ \ | |_) | |   | |_| |
    //   ___) | |___ / ___ \|  _ <| |___|  _  |
    //  |____/|_____/_/   \_\_| \_\\____|_| |_|
    //
    // MACHINES BIS
    {
        path: '/search-machines',
        name: 'search-machines',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/research/machines/Results.vue'),
    },

    {
        path: '/search-markets',
        name: 'search-markets',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/research/machines/Markets.vue'),
    },

    // SERVICES
    {
        path: '/search-services',
        name: 'research-services-results',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/research/services/Results.vue'),
    },

    // ACCESSOIRES

    {
        path: '/search-accessories',
        name: 'search-accessories',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/research/accessories/Results.vue'),
    },
    // SERVICES
    {
        path: '/search-services',
        name: 'search-services',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/research/services/Results.vue'),
    },
    // INNOVATIONS
    {
        path: '/search-innovations',
        name: 'search-innovations',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'search',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/research/innovations/Results.vue'),
    },
    //   __  __    _    ____ _   _ ___ _   _ _____   ____  _   _ _____ _____ _____
    //  |  \/  |  / \  / ___| | | |_ _| \ | | ____| / ___|| | | | ____| ____|_   _|
    //  | |\/| | / _ \| |   | |_| || ||  \| |  _|   \___ \| |_| |  _| |  _|   | |
    //  | |  | |/ ___ \ |___|  _  || || |\  | |___   ___) |  _  | |___| |___  | |
    //  |_|  |_/_/   \_\____|_| |_|___|_| \_|_____| |____/|_| |_|_____|_____| |_|
    //
    {
        path: '/machine-sheet/:name/:id/summary',
        name: 'machine-sheet-summary',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Summary.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/handover',
        name: 'machine-sheet-handover',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Handover.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/showroom',
        name: 'machine-sheet-showroom',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Showroom.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/documents',
        name: 'machine-sheet-documents',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Documents.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/arguments',
        name: 'machine-sheet-arguments',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Arguments.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/features',
        name: 'machine-sheet-features',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Features.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/accessories',
        name: 'machine-sheet-accessories',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Accessories.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/equipments',
        name: 'machine-sheet-equipments',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Equipments.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/compare',
        name: 'machine-sheet-compare',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Comparison.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/capacity',
        name: 'machine-sheet-capacity',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Capacity.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/autonomy',
        // path: '/machine-sheet/autonomy',
        name: 'machine-sheet-autonomy',
        meta: {
            layout: 'sheet',
            // layout: 'with-top-navigation',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/machine/Autonomy.vue'),
    },
    {
        path: '/machine-sheet/:name/:id/long-sheet',
        name: 'machine-sheet-long-sheet',
        meta: {
            layout: 'sheet',
            sheetType: 'machine',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/sheet/machine/LongPageSheet.vue'),
    },
    //      _    ____ ____ _____ ____ ____   ___  ______   __  ____  _   _ _____ _____ _____
    //     / \  / ___/ ___| ____/ ___/ ___| / _ \|  _ \ \ / / / ___|| | | | ____| ____|_   _|
    //    / _ \| |  | |   |  _| \___ \___ \| | | | |_) \ V /  \___ \| |_| |  _| |  _|   | |
    //   / ___ \ |___ |___| |___ ___) |__) | |_| |  _ < | |    ___) |  _  | |___| |___  | |
    //  /_/   \_\____\____|_____|____/____/ \___/|_| \_\|_|   |____/|_| |_|_____|_____| |_|
    //
    {
        path: '/accessory-sheet/:name/:id/summary',
        name: 'accessory-sheet-summary',
        meta: {
            layout: 'sheet',
            sheetType: 'accessory',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/accessory/Summary.vue'),
    },
    {
        path: '/accessory-sheet/:name/:id/showroom',
        name: 'accessory-sheet-showroom',
        meta: {
            layout: 'sheet',
            sheetType: 'accessory',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/accessory/Showroom.vue'),
    },
    {
        path: '/accessory-sheet/:name/:id/documents',
        name: 'accessory-sheet-documents',
        meta: {
            layout: 'sheet',
            sheetType: 'accessory',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/accessory/Documents.vue'),
    },
    {
        path: '/accessory-sheet/:name/:id/features',
        name: 'accessory-sheet-features',
        meta: {
            layout: 'sheet',
            sheetType: 'accessory',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/accessory/Features.vue'),
    },
    //   ____  _____ ______     _____ ____ _____   ____  _   _ _____ _____ _____
    //  / ___|| ____|  _ \ \   / /_ _/ ___| ____| / ___|| | | | ____| ____|_   _|
    //  \___ \|  _| | |_) \ \ / / | | |   |  _|   \___ \| |_| |  _| |  _|   | |
    //   ___) | |___|  _ < \ V /  | | |___| |___   ___) |  _  | |___| |___  | |
    //  |____/|_____|_| \_\ \_/  |___\____|_____| |____/|_| |_|_____|_____| |_|
    //
    {
        path: '/service-sheet/:name/:id/summary',
        name: 'service-sheet-summary',
        meta: {
            layout: 'sheet',
            sheetType: 'service',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/service/Summary.vue'),
    },
    {
        path: '/service-sheet/:name/:id/showroom',
        name: 'service-sheet-showroom',
        meta: {
            layout: 'sheet',
            sheetType: 'service',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/service/Showroom.vue'),
    },
    {
        path: '/service-sheet/:name/:id/documents',
        name: 'service-sheet-documents',
        meta: {
            layout: 'sheet',
            sheetType: 'service',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/service/Documents.vue'),
    },
    {
        path: '/service-sheet/:name/:id/arguments',
        name: 'service-sheet-arguments',
        meta: {
            layout: 'sheet',
            sheetType: 'service',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/service/Arguments.vue'),
    },
    {
        path: '/service-sheet/:name/:id/faqs',
        name: 'service-sheet-faqs',
        meta: {
            layout: 'sheet',
            sheetType: 'service',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/service/Faqs.vue'),
    },
    {
        path: '/service-sheet/:name/:id/compare',
        name: 'service-sheet-compare',
        meta: {
            layout: 'sheet',
            sheetType: 'service',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/service/Comparison.vue'),
    },
    //   ____  _____ ______     _____ ____ _____   ____  _   _ _____ _____ _____
    //  / ___|| ____|  _ \ \   / /_ _/ ___| ____| / ___|| | | | ____| ____|_   _|
    //  \___ \|  _| | |_) \ \ / / | | |   |  _|   \___ \| |_| |  _| |  _|   | |
    //   ___) | |___|  _ < \ V /  | | |___| |___   ___) |  _  | |___| |___  | |
    //  |____/|_____|_| \_\ \_/  |___\____|_____| |____/|_| |_|_____|_____| |_|
    //
    {
        path: '/innovation-sheet/:name/:id/summary',
        name: 'innovation-sheet-summary',
        meta: {
            layout: 'sheet',
            sheetType: 'innovations',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/innovation/Summary.vue'),
    },
    /*{
        path: '/innovation-sheet/:name/:id/pictures',
        name: 'innovation-sheet-pictures',
        meta: {
            layout: 'sheet',
            sheetType: 'innovations',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/innovation/Pictures.vue'),
    },
    {
        path: '/innovation-sheet/:name/:id/videos',
        name: 'innovation-sheet-videos',
        meta: {
            layout: 'sheet',
            sheetType: 'innovations',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/innovation/Videos.vue'),
    },*/
    {
        path: '/innovation-sheet/:name/:id/showroom',
        name: 'innovation-sheet-showroom',
        meta: {
            layout: 'sheet',
            sheetType: 'innovations',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/sheet/innovation/Showroom.vue'),
    },
    //    ____ ___  __  __ ____   _    ____  _____
    //   / ___/ _ \|  \/  |  _ \ / \  |  _ \| ____|
    //  | |  | | | | |\/| | |_) / _ \ | |_) |  _|
    //  | |___ |_| | |  | |  __/ ___ \|  _ <| |___
    //   \____\___/|_|  |_|_| /_/   \_\_| \_\_____|
    //
    {
        path: '/compare/selection/:machineId?',
        name: 'compare-selection',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'compare',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/compare/MachinesSelection.vue'),
    },
    {
        path: '/compare/comparison',
        name: 'compare-comparison',
        meta: {
            layout: 'with-top-navigation',
            authNeeded: true,
            navigationActive: 'compare',
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/compare/MachinesComparison.vue'),
    },
    //    ___  _   _   _    _     ___ _______   __
    //   / _ \| | | | / \  | |   |_ _|  ___\ \ / /
    //  | | | | | | |/ _ \ | |    | || |_   \ V /
    //  | |_| | |_| / ___ \| |___ | ||  _|   | |
    //   \__\_\\___/_/   \_\_____|___|_|     |_|
    //
    {
        path: '/qualify',
        name: 'qualify',
        meta: {
            layout: 'blank',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/qualify/Index.vue'),
    },
    //    ___  _   _   _    _     ___ _______   __          ___           _           _
    //   / _ \| | | | / \  | |   |_ _|  ___\ \ / /         |_ _|_ __   __| |_   _ ___| |_ _ __ _   _
    //  | | | | | | |/ _ \ | |    | || |_   \ V /   _____   | || '_ \ / _` | | | / __| __| '__| | | |
    //  | |_| | |_| / ___ \| |___ | ||  _|   | |   |_____|  | || | | | (_| | |_| \__ \ |_| |  | |_| |
    //   \__\_\\___/_/   \_\_____|___|_|     |_|           |___|_| |_|\__,_|\__,_|___/\__|_|   \__, |
    //                                                                                         |___/
    {
        path: '/qualify-industry',
        name: 'qualify-selection',
        meta: {
            layout: 'blank',
            qualifyType: 'industry',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/qualify/industry/EnvironmentSelection.vue'),
    },
    {
        path: '/qualify-industry/:step',
        name: 'qualify-industry',
        meta: {
            layout: 'qualify',
            qualifyType: 'industry',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/qualify/industry/Index.vue'),
    },
    //    ___  _   _   _    _     ___ _______   __          ___           _           _
    //   / _ \| | | | / \  | |   |_ _|  ___\ \ / /         |_ _|_ __   __| |_   _ ___| |_ _ __ _   _
    //  | | | | | | |/ _ \ | |    | || |_   \ V /   _____   | || '_ \ / _` | | | / __| __| '__| | | |
    //  | |_| | |_| / ___ \| |___ | ||  _|   | |   |_____|  | || | | | (_| | |_| \__ \ |_| |  | |_| |
    //   \__\_\\___/_/   \_\_____|___|_|     |_|           |___|_| |_|\__,_|\__,_|___/\__|_|   \__, |
    //                                                                                         |___/
    {
        path: '/qualify-construction/:step',
        name: 'qualify-construction',
        meta: {
            layout: 'qualify',
            qualifyType: 'construction',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in'
        },
        component: () => import('../views/qualify/construction/Index.vue'),
    },
    //   _____ ______     _____ _______        _______ ____
    //  |___ /|  _ \ \   / /_ _| ____\ \      / / ____|  _ \
    //    |_ \| | | \ \ / / | ||  _|  \ \ /\ / /|  _| | |_) |
    //   ___) | |_| |\ V /  | || |___  \ V  V / | |___|  _ <
    //  |____/|____/  \_/  |___|_____|  \_/\_/  |_____|_| \_\
    //
    /*{
        path: '/3d-viewer',
        name: '3d-viewer',
        meta: {
            layout: 'blank',
            authNeeded: true,
            viewsTransition: 'fade',
            viewsTransitionMode: 'out-in',
            keepAlive: true
        },
        component: () => import('../views/3DViewer.vue'),
    },*/
    //   _____ _    _     _     ____    _    ____ _  __
    //  |  ___/ \  | |   | |   | __ )  / \  / ___| |/ /
    //  | |_ / _ \ | |   | |   |  _ \ / _ \| |   | ' /
    //  |  _/ ___ \| |___| |___| |_) / ___ \ |___| . \
    //  |_|/_/   \_\_____|_____|____/_/   \_\____|_|\_\
    //
    {
        path: '*',
        redirect: '/home'
    }
]

let routes = (process.env.VUE_APP_ENV === 'production' ? routesProd : routesDev);

Array.prototype.push.apply(routes, routesCommon);

Vue.use(Router);

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { y: 0 }
    },
    routes: routes
})

// ROUTER CHECK AUTH
router.beforeEach((to, from, next) => {
    // A chaque fois que l'on veux acceder a la fiche d'un produit,
    // on enregistre la route actuelle pour y revenir avec le bouton retour
    let sheets = [
        'machine-sheet-summary',
        'accessory-sheet-summary',
        'service-sheet-summary',
        'innovation-sheet-summary'
    ];

    if(sheets.includes(to.name) && to.params.saveRoute){
        store.commit('sheet/setReturnRoute', {
            name: from.name,
            path: from.path,
            params: from.params,
            query: from.query,
        })
        next();
    }
    else if(to.name.includes('qualify')) {
        if ((from.name && from.name.includes('qualify') && from.meta.layout === "qualify") && (to.query.init && !to.query.backward)) to.query.backward = true
        next()
    }
    else {
        next();
    }
});

export default router;
